var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 4.5L20.1453 12.4677C20.407 13.44 20.538 13.9261 20.7963 14.3236C21.0249 14.6752 21.3248 14.975 21.6765 15.2037C22.0739 15.462 22.56 15.593 23.5323 15.8547L31.5 18L23.5323 20.1453C22.56 20.407 22.0739 20.538 21.6765 20.7963C21.3248 21.0249 21.0249 21.3248 20.7963 21.6765C20.538 22.0739 20.407 22.56 20.1453 23.5323L18 31.5L15.8547 23.5323C15.593 22.56 15.462 22.0739 15.2037 21.6765C14.975 21.3248 14.6752 21.0249 14.3236 20.7963C13.9261 20.538 13.44 20.407 12.4677 20.1453L4.5 18L12.4677 15.8547C13.44 15.593 13.9261 15.462 14.3236 15.2037C14.6752 14.975 14.975 14.6752 15.2037 14.3236C15.462 13.9261 15.593 13.44 15.8547 12.4677L18 4.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium-plan.f97c26666a5a4ca48ef3d666a4966720.svg";
export { ForwardRef as ReactComponent };